import { createStyles } from '@mantine/core'

const useVirtuosoTableStyles = createStyles((theme) => ({
  zeroPaddingTd: {
    padding: '0 !important',
  },

  tdText: {
    [theme.fn.smallerThan('md')]: {
      fontSize: `${theme.fontSizes.xs} !important`,
    },
  },
}))

export default useVirtuosoTableStyles
